"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExploreMoreCTA() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative py-24 md:py-32 bg-[hsl(210,15%,15%)] text-white overflow-hidden" aria-labelledby="explore-more-heading">
      <div className="container mx-auto px-6 max-w-4xl text-center">
        <h2 id="explore-more-heading" ref={headlineRef} className={`font-sans text-3xl md:text-4xl lg:text-5xl font-bold mb-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        textShadow: "0 0 20px hsla(215, 80%, 48%, 0.3)"
      }}>
          Ready to Bring Your Vision to Life?
        </h2>

        <div ref={buttonRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${buttonVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: "100ms"
      }}>
          <Link to="/ContactPage">
            <Button size="lg" className="relative bg-[hsl(40,90%,55%)] text-white hover:bg-[hsl(40,88%,60%)] active:bg-[hsl(40,88%,50%)] px-8 py-6 text-lg font-semibold rounded-md shadow-medium hover:shadow-strong hover:scale-[1.02] active:scale-100 transition-all duration-[120ms] ease-[var(--ease-spring)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(215,80%,48%)] overflow-hidden group">
              <span className="relative z-10">Get Started</span>
              <span className="absolute inset-0 bg-white/20 rounded-full scale-0 group-active:scale-100 transition-transform duration-300 ease-out" style={{
              transformOrigin: "center"
            }} />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}